import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { setAlert } from '../../../redux/dashboard/actions';
import { getUser } from '../../../redux/user/actions';

import api from '../../../services/api';
import utils from '../../../utils';
import { initializeCredential } from '../../../utils/integrations';

import components from '../../../components';
const { SearchBox, CustomButton, CustomInput, Timezone, EmptyState } = components;

import CMSAccount from '../cmsAccount';
import { getSelectedProject } from '../../../redux/projects/actions';

// input validations
const validations = {
  displayName: [{ key: 'required', value: true }]
};

const AccountsTab = ({
  credentials,
  loading,
  selectedIntegration,
  loadCredentials,
  isCreateModalOpen,
  closeCreateModal
}) => {
  const [filteredCredentials, setFilteredCredentials] = useState(credentials);
  const [values, setValues] = useState({});
  const [displayName, setDisplayName] = useState('');
  const [errors, setErrors] = useState({ 'new-mappings-display-name': '' });

  const dispatch = useDispatch();
  const project = useSelector(getSelectedProject);
  const user = useSelector(getUser);

  useEffect(() => {
    setFilteredCredentials(credentials);
  }, [credentials]);

  useEffect(() => {
    if (selectedIntegration && selectedIntegration?.mappingCredentialFields) {
      setValues(initializeCredential(selectedIntegration.mappingCredentialFields));
    } else {
      setValues({});
    }
  }, []);

  useEffect(() => {
    // Update error accumulator when updating form
    // Add values to the listeners if we need additional validation
    setErrors({
      'new-mappings-display-name': utils.fieldValidation(displayName, validations['displayName']).join(', ')
    });
  }, [displayName]);

  useEffect(() => {
    if (selectedIntegration && selectedIntegration?.mappingCredentialFields) {
      setValues(initializeCredential(selectedIntegration.mappingCredentialFields));
    } else {
      setValues({});
    }
  }, [selectedIntegration]);

  const searchDevices = searchBy => {
    if (searchBy !== '') {
      setFilteredCredentials(
        credentials.filter(mapping => {
          const credentialHas = option => mapping[option].toUpperCase().includes(searchBy.toUpperCase());
          return credentialHas('displayName') || credentialHas('id');
        })
      );
    } else {
      setFilteredCredentials(credentials);
    }
  };

  const createAccount = () => {
    if (utils.hasErrorsCheck(errors)) {
      dispatch(
        setAlert(utils.generateAlert('Could not create Credential! Is something wrong with the form?', 'error'))
      );
    } else {
      const cmsName = selectedIntegration.vendor.toLowerCase();

      api
        .createCredential(project.id, {
          displayName,
          creatorId: user.id,
          credential: { [`${cmsName}`]: values }
        })
        .then(() => {
          dispatch(setAlert(utils.generateAlert('Credential created successfuly!', 'success')));
          loadCredentials();
          setValues(initializeCredential(selectedIntegration.mappingCredentialFields));
          setDisplayName('');
          closeCreateModal();
        })
        .catch(err => {
          console.error(err);
          dispatch(setAlert(utils.generateAlert('Could not create Credential! Please try again.', 'error')));
        });
    }
  };

  const updateForm = (field, val) => {
    setValues({ ...values, [field]: val });
  };

  const resetForm = () => {
    setDisplayName('');
    setValues(initializeCredential(selectedIntegration.mappingCredentialFields));
    closeCreateModal();
  };

  const renderCustomFields = () => {
    return selectedIntegration.mappingCredentialFields.map(field => (
      <div className="col" key={field}>
        <div className="form-group">
          <label>{field}</label>
          {field === 'pop_timezone' ? (
            <Timezone
              onSelect={value => {
                updateForm(field, value);
              }}
            />
          ) : (
            <CustomInput
              id={`new-mappings-${field}`}
              type="text"
              value={values[field]}
              isEditable
              onChange={e => {
                updateForm(field, e.target.value);
              }}
            />
          )}
        </div>
      </div>
    ));
  };

  const renderLoading = () => {
    return <p>Loading...</p>;
  };

  const renderContent = () => {
    return credentials.length > 0 ? (
      <>
        <SearchBox placeholder="Search by Display Name" className="outline" onChange={searchDevices} />
        {filteredCredentials.length > 0 ? (
          <div>
            {filteredCredentials.map(credential => {
              return (
                <CMSAccount
                  key={credential.id}
                  credential={credential}
                  credentialFields={selectedIntegration.mappingCredentialFields}
                  loadCredentials={loadCredentials}
                />
              );
            })}
          </div>
        ) : (
          <div className="no-results-found">
            <p>No credentials were found</p>
          </div>
        )}
      </>
    ) : (
      <EmptyState
        icon={'addUser'}
        title={`You don't have any accounts.`}
        details={`Create your first account by clicking the button "Add Account".`}
      />
    );
  };

  return (
    <div>
      {loading ? renderLoading() : renderContent()}
      <Modal size="lg" isOpen={isCreateModalOpen} fade={false} centered toggle={resetForm} className="integration-create-modal">
        <ModalHeader className="header-gray" tag="div">
          <h5>Add Account</h5>
        </ModalHeader>
        <ModalBody>
          <div className="account-fields">
            <div className="form-row">
              <div className="col">
                <div className="form-group">
                  <label>Display Name</label>
                  <CustomInput
                    id={`new-mappings-display-name`}
                    type="text"
                    value={displayName}
                    isEditable
                    autoFocus
                    errorMessage={errors['new-mappings-display-name']}
                    onChange={e => {
                      setDisplayName(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="form-row">{renderCustomFields()}</div>
          </div>
        </ModalBody>
        <ModalFooter>
          <CustomButton classes="btn-secondary" title="Cancel" handleClick={resetForm} />
          <CustomButton classes="btn-primary" title="Create" handleClick={createAccount} />
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AccountsTab;
